<template>
	<div>
		<div class="wrap">
			<Title title="投票记录"></Title>
			<div class="activity-form-wrap">
				<el-form :inline="true" class="activity-form">
					<el-form-item label="选手名称">
						<el-input v-model="playerName" placeholder="请输入活动名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">搜索</el-button>
						<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-table border :data="recordList" style="width: 100%">
				<el-table-column prop="playerName" label="选手名称">
				</el-table-column>
				<el-table-column prop="voterName" label="投票人">
				</el-table-column>
				<el-table-column prop="beforeVoterCount" label="投票前数量">
				</el-table-column>
				<el-table-column prop="afterVoterCount" label="投票后数量">
				</el-table-column>
				<el-table-column prop="voterCount" label="投票数量">
				</el-table-column>
				<el-table-column label="投票日期">
					<template slot-scope="scope">
						{{ scope.row.voterDate | datefmt2('YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		post,
		ajaxParam
	} from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	export default {
		name: 'VoteLog',
		components: {
			Title,
			Pagination
		},
		data() {
			return {
				pageSize: 10,
				pageNum: 1,
				total: 0,
				voteId: '', //投票id
				playerName: '',
				recordList: [],
				companyId: ''
			}
		},
		created() {
			this.voteId = this.$route.query.voteId
			this.getRecordList()
		},
		methods: {
			//获取投票记录列表
			async getRecordList() {
				let param = {
					voteId: this.voteId,
					playerName: this.playerName,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/recordList', qs.stringify(param))
				console.log(res.data.page.items)
				let datalist = res.data.page.items
				this.recordList = datalist
				this.total = res.data.page.count
			},
			toSearch() {
				this.pageNum = 1
				this.total = 0
				this.getRecordList()
			},
			toReset() {
				this.playerName = ''
				this.pageNum = 1
				this.total = 0
				this.recordList = []
				this.getRecordList()
			},
			//分页
			handleCurrentChange(e){
				this.recordList = []
				this.pageNum = e.number
				this.getRecordList()
			},
		}
	}
</script>

<style scoped lang="less">
	.wrap /deep/ .el-table .el-table__cell {
		padding: 6px 0 !important;
		font-size: 12px;
	}

	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}

	.pagination {
		margin-top: 10px;
	}

	.title /deep/ .el-button--warning {
		background-color: #EB6B1B
	}

	.title /deep/ .el-button--mini {
		padding: 4px 10px;
	}

	.activity-form-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 15px;
	}

	.dropdown-new {
		li {
			height: 26px;
			line-height: 26px;
			font-size: 12px;
			color: #EB6B1B;
		}

		li:hover {
			background: none;
			text-decoration: underline;
			color: #EB6B1B;
		}
	}

	/deep/ .el-form-item {
		margin-bottom: 0;
	}

	/deep/ .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px !important;
	}

	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}

	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 8px;
	}

	/deep/ .el-button {
		font-size: 12px !important;
	}

</style>